<!--==========================
=            APPS            =
===========================-->
<template>
  <!-- APP -->
  <v-app class="app" v-cloak :dark="appConfig.dark">
    <!-- APP-PARALLAX -->
    <app-parallax></app-parallax>
    <!-- APP-TOP -->
    <app-top v-if="$route.fullPath !== '/'"></app-top>
    <!-- APP-DARW -->
    <!-- <app-drawer v-if="$route.fullPath !== '/'">
      <app-drawer-list :obj="{list:routes}"></app-drawer-list>
    </app-drawer>-->
    <router-view class="app__router" :class="{'app__router--small':appConfig.small}"></router-view>
    <!-- FOOTER -->
    <footerCompanyFooter></footerCompanyFooter>
    <!-- <footerTealFooter></footerTealFooter> -->
  </v-app>
</template>
<script>
export default {
  name: "app",
  mounted() {
    let vm = this;
    vm.$vuetify.theme.primary = vm.appConfig.primary[0];
  },
  data() {
    return {};
  }
};
</script>
<style>
.flex-column {
  flex-direction: column;
}

body {
  font-family: "Roboto";
  font-size: 14px;
  background: #fafafa;
  text-rendering: geometricPrecision;
}

.container {
  max-width: 1200px !important;
}

.app {
  background: #fafafa;
}

.app.theme--dark {
  background: #303030;
}

.app__router {
  min-height: calc(100vh - 102px);
  /* margin-left: 235px; */

  /* テンプレートを上書き */
  margin-left: 50px;
  margin-right: 50px;
}

.app__router--small {
  margin-left: 65px;
}



@media (max-width: 960px) {
  .app__router {
    margin-left: 25px;
  }
}
</style>
<!--====  End of APPS  ====-->



// WEBPACK FOOTER //
// src/App.vue